import { render, staticRenderFns } from "./RecebimentoDeNotaFiscalRejeitarItemView.vue?vue&type=template&id=60471a55&scoped=true"
import script from "./RecebimentoDeNotaFiscalRejeitarItemView.vue?vue&type=script&lang=js"
export * from "./RecebimentoDeNotaFiscalRejeitarItemView.vue?vue&type=script&lang=js"
import style0 from "./RecebimentoDeNotaFiscalRejeitarItemView.vue?vue&type=style&index=0&id=60471a55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60471a55",
  null
  
)

export default component.exports